"use client";

import { useEffect } from "react";
import { useAppSelector } from "@/store/hooks";

export default function DarkModeClientEffect() {
  const isDark = useAppSelector((state) => state.darkMode.enabled);

  useEffect(() => {
    // Toggle the class on the root element so Tailwind dark: variants activate everywhere
    document.documentElement.classList.toggle("dark", isDark);
  }, [isDark]);

  return null;
}
